@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import ru.dinarastepina.fabvocab.pages.AddWordPage as _ru_dinarastepina_fabvocab_pages_AddWordPage
import ru.dinarastepina.fabvocab.pages.HomePage as _ru_dinarastepina_fabvocab_pages_HomePage
import ru.dinarastepina.fabvocab.pages.LoginPage as _ru_dinarastepina_fabvocab_pages_LoginPage
import ru.dinarastepina.fabvocab.pages.PracticePage as _ru_dinarastepina_fabvocab_pages_PracticePage
import ru.dinarastepina.fabvocab.pages.words.id.WordDetailPage as _ru_dinarastepina_fabvocab_pages_words_id_WordDetailPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "FabVocab Web"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _ru_dinarastepina_fabvocab_pages_HomePage()
        }
        ctx.router.register(
            "/add",
        ) { pageCtx -> 
            _ru_dinarastepina_fabvocab_pages_AddWordPage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _ru_dinarastepina_fabvocab_pages_LoginPage()
        }
        ctx.router.register(
            "/practice",
        ) { pageCtx -> 
            _ru_dinarastepina_fabvocab_pages_PracticePage()
        }
        ctx.router.register(
            "/words/{id}",
        ) { pageCtx -> 
            _ru_dinarastepina_fabvocab_pages_words_id_WordDetailPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        ru.dinarastepina.fabvocab.web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
